import PropTypes from 'prop-types';
import UnlockAdSlot from '../ads/UnlockAdSlot';

export default function UnlockActivityView({
  unlockActions,
  campaignId,
  campaignKey,
  unlockToken,
}) {
  return (
    <UnlockAdSlot
      id="unlockSlot"
      unlockActions={unlockActions}
      campaignId={campaignId}
      campaignKey={campaignKey}
      unlockToken={unlockToken}
    />
  );
}

UnlockActivityView.propTypes = {
  unlockActions: PropTypes.object.isRequired,
  campaignId: PropTypes.number,
  campaignKey: PropTypes.string,
  unlockToken: PropTypes.string,
};
